var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-transaction"},[_c('back-button'),_c('router-view',{attrs:{"tokens-with-balance":_vm.tokensWithBalance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }